import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Badge,
  Input,
} from "reactstrap"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import moment from "moment"
import ButtonSpinner from "../../components/ButtonSpinner"
//Import Styles
import "./styles.scss"
//Data Table packeages
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { ReactSearchAutocomplete } from "react-search-autocomplete"

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { CSVExport } from "react-bootstrap-table2-toolkit"

// import Multiselect from "multiselect-react-dropdown"

//components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as followupFeedbackAction from "../../store/Zm9sbG93dXBGZWVkYmFjaw/actions"
import * as auditAction from "../../store/c2FsZXNG/actions" //for using employee options

const FollowupFeedback = (props) => {
  const { dispatch, searchBarStyle } = props
  const title = "Followup Audit Feedback"

  //Search bar and validations
  const { SearchBar } = Search
  const specificDispatch = useDispatch()
  const today = moment().format("YYYY-MM-DD")
  var date = new Date()
  var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
  const startingDay = moment(firstDay).format("YYYY-MM-DD")
  useEffect(() => {
    dispatch(followupFeedbackAction.loadRecordsMetaData())
    dispatch(auditAction.loadEmployee())
    dispatch(followupFeedbackAction.loadFollowupFeedbackList({
      auditFromDate: startingDay,
      auditToDate: today
    }))
    setFollowupData({
      auditFromDate: startingDay,
      auditToDate: today,
    })
  }, [])

  const followupUpdate = useSelector((state) => state.followupFeedback)


  const { followupFeedbackData = {}, followup_feedback_report = [] } =
    followupUpdate
  const employeeUpdate = useSelector((state) => state.salesfollowup)

  const { employee_list = [] } = employeeUpdate

  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate


  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""


  //Followup feedback initial state
  const [followupData, setFollowupData] = useState({
    company: [],
    branch: [],
    event: [],
    fromDate: "",
    auditFromDate: "",
    auditToDate: "",
    toDate: "",
    leadNo: "",
  })

  //Handle change

  const handleChange = async (e) => {
    setFollowupData({ ...followupData, [e.target.name]: e.target.value })
  }

  //dropdown initial state
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [salesAgent, setSalesAgent] = useState([])
  const [agentKey, setAgentKey] = useState(false)
  //reset functionalities
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setAgentKey(true)
    setTimeout(() => { setAgentKey(false) }, 0)
    setSalesAgent([])
    setFollowupData({
      fromDate: "",
      toDate: "",
      leadNo: "",
      auditFromDate: startingDay,
      auditToDate: today,
    })

    dispatch(followupFeedbackAction.loadFollowupFeedbackList())
  }

  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)
  //dropdown options

  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)
  const branchOptions =
    !isEmpty(followupFeedbackData) &&
    followupFeedbackData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )

  //employee options(agent options)

  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        roleId: employee.roleId,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.companyId = element.companyId
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const salesAgentOptions = createOptions(employeeList)
  //fuse options for venue(autocomplete field)
  const fuseOptions = {
    keys: ["empCode", "label"],
  }

  //Apply filter submit

  const applyFilter = () => {
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchAgent = salesAgent && salesAgent.value ? salesAgent.value : ""

    var searchLeadNo =
      followupData && followupData.leadNo ? followupData.leadNo : ""
    var searchFromDate =
      followupData && followupData.fromDate
        ? moment(followupData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      followupData && followupData.toDate
        ? moment(followupData.toDate).format("YYYY-MM-DD")
        : ""
    var searchAuditFromDate =
      followupData && followupData.auditFromDate
        ? moment(followupData.auditFromDate).format("YYYY-MM-DD")
        : ""
    var searchAuditToDate =
      followupData && followupData.auditToDate
        ? moment(followupData.auditToDate).format("YYYY-MM-DD")
        : ""

    var searchValue = {}
    if (searchCompany) {
      searchValue.companyId = searchCompany
    }

    if (searchBranch) {
      searchValue.branchId = searchBranch
    }
    if (searchAgent) {
      searchValue.agent = searchAgent
    }
    if (searchLeadNo) {
      searchValue.leadNo = searchLeadNo
    }
    if (searchFromDate) {
      searchValue.fromDate = searchFromDate
    }
    if (searchAuditFromDate) {
      searchValue.auditFromDate = searchAuditFromDate
    }
    if (searchAuditToDate) {
      searchValue.auditToDate = searchAuditToDate
    }
    if (searchToDate) {
      searchValue.toDate = searchToDate
    }
    specificDispatch(
      followupFeedbackAction.loadFollowupFeedbackList(searchValue)
    )
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

  //Data table for Offer

  let slNo = 0
  const followupReportTable = !isEmpty(followup_feedback_report)
    ? followup_feedback_report.map((data, index) => {
      slNo = slNo + 1

      var followupDate = !isEmpty(data.followupDate)
        ? moment(data.followupDate).format(dateFormate)
        : []

      var followupTime =
        !isEmpty(data.followupTime) &&
        data.followupTime.slice(0, 2)
      var followupMinutes =
        !isEmpty(data.followupTime) &&
        data.followupTime.slice(3)

      var followupTimeSlot =
        !isEmpty(followupTime) && followupTime == 12
          ? followupTime
          : followupTime - 12

      const dataTime =
        !isEmpty(followupTime) && followupTime >= 12
          ? followupTimeSlot + ":" + followupMinutes + " " + "PM"
          : data.followupTime + " " + "AM"

      //    ? followupTime + "AM"
      //   : followupTime + "PM"
      var leadDate = !isEmpty(data.leadDate)
        ? moment(data.leadDate)
          .subtract(5, "hours")
          .subtract(30, "minutes")
          .format(`${dateFormate} hh:mm A`)
        : []
      var auditDate = !isEmpty(data.auditOn)
        ? moment(data.auditOn)
          .subtract(5, "hours")
          .subtract(30, "minutes")
          .format(dateFormate)
        : []
      const colorCode =
        !isEmpty(followupFeedbackData) &&
        followupFeedbackData.processStatusOptions &&
        followupFeedbackData.processStatusOptions.length > 0 &&
        followupFeedbackData.processStatusOptions.find(
          (_) => _.processStatusId === data.processStatus
        ) &&
        followupFeedbackData.processStatusOptions.find(
          (_) => _.processStatusId === data.processStatus
        ).colorCode

      return {
        _id: data._id,
        sNo: slNo,
        leadNo: data.leadNo,
        branchId: data.branchId,
        leadStatus: (
          <button
            style={{
              background: colorCode,
              border: "none",
              cursor: "pointer",
              color: "white",
              padding: "5px 6px",
              borderRadius: "4px",
            }}
          >
            {!isEmpty(data.processStatusName)
              ? data.processStatusName
              : []}
          </button>
        ),
        clientCode: !isEmpty(data.clientCode)
          ? data.clientCode
          : "--",
        clientName: !isEmpty(data.clientFirstName)
          ? data.clientFirstName + " " + data.clientLastName
          : "",
        followupNo: data.followupNo,
        followupDate: followupDate + " " + dataTime,
        agentName: !isEmpty(data.salesAgentName)
          ? data.salesAgentName
          : "--",
        auditStatus: (
          <Badge
            color={
              data.auditStatus === "Pending"
                ? "warning"
                : data.auditStatus === "valid"
                  ? "success"
                  : "danger"
            }
            style={{ padding: "10px", fontSize: "12px" }}
          >
            {!isEmpty(data) && data.auditStatus}
          </Badge>
        ),
        leadStatusCsv: !isEmpty(data.processStatusName)
          ? data.processStatusName
          : "",
        auditStatusCsv: !isEmpty(data) && data.auditStatus ? data.auditStatus : "",
        callOpening: data.callOpening ? data.callOpening : "--",
        callClosing: data.callClosing ? data.callClosing : "--",

        urgencyToSell: data.urgencytoSell ? data.urgencytoSell : "--",
        demandCreation: data.demandCreation ? data.demandCreation : "--",
        rapport: data.rappot ? data.rappot : "--",
        engagementDetails:
          !isEmpty(data.engagementDetails) &&
            data.engagementDetails === "true"
            ? "YES"
            : "NO",

        reference:
          !isEmpty(data.reference) &&
            data.reference === "true"
            ? "YES"
            : "NO",
        overallCallRating: data.overallCallRating ? data.overallCallRating : "--",
        auditOn: auditDate,
        auditName: data.auditName,
        remarks: data.auditRemarks ? data.auditRemarks : "--",
        leadDate: leadDate,
        key: index,
        clientDetails: data.clientDetails ? data.clientDetails : "--",
        eventDetails: data.eventDetails ? data.eventDetails : "--",
        budgetDetails: data.budgetDetails ? data.budgetDetails : "--",
        clientProfile: data.clientProfile ? data.clientProfile : "--",
        greenFlag: data.greenFlagremarks ? data.greenFlagremarks : "--",
        salesPyramid: data.salesPyramid ? data.salesPyramid : "--",
        venueDetails: data.venueDetails ? data.venueDetails : "--",
        futureFollowupDate: data.futureFollowupDate ? data.futureFollowupDate : "--",
        probing:
          data.probing && data.probing || "--",
        crossPitch:
          data.crossPitch || "--",
        clientVisit: data.clientVisit || "--",
        quoteShared: data.quote_shared || "--",

        meeting: data.meeting || "--",

        crossSelling: data.zgp_crossselling || "--",

        foodTasting: data.dc_foodtasting || "--",

        designSelection: data.ver_designselection || "--",

        sendingQuote: data.ver_sendingquote || "--",

        menuShared: data.dc_menushared && data.dc_menushared || "--",


      }
    })
    : []

  //download feature in data tables
  const { ExportCSVButton } = CSVExport

  //columns for data table
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "leadDate",
      text: "Lead Date",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "clientCode",
      text: "Client Code",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name",
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "followupNo",
      text: "Followup No",
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "followupDate",
      text: "Followup Date",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "leadStatus",
      text: "Lead Status",
      style: {
        color: "#e83e8c",
        cursor: "pointer",
      },
      csvExport: false,
      headerStyle: {
        minWidth: "135px",
      },
    },
    {
      dataField: "leadStatusCsv",
      text: "Lead Status",
      style: {
        color: "#e83e8c",
        cursor: "pointer",
      },
      hidden: true,
      headerStyle: {
        minWidth: "135px",
      },
    },
    {
      dataField: "agentName",
      text: "Sales Agent Name",
      sort: true,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "auditStatus",
      text: "Audit Status",
      csvExport: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "auditStatusCsv",
      text: "Audit Status",
      hidden: true,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "quoteShared",
      text: "Quote Shared",
      headerStyle: {
        minWidth: "130px",
      },
      style: {
        fontWeight: "bold"
      },
    },

    {
      dataField: "meeting",
      text: "Meeting",
      headerStyle: {
        minWidth: "130px",
      },
      style: {
        fontWeight: "bold"
      },
    },
    {
      dataField: "crossSelling",
      text: "Cross Selling",
      headerStyle: {
        minWidth: "130px",
      },
      style: {
        fontWeight: "bold"
      },
    },
    {
      dataField: "menuShared",
      text: "Menu Shared",
      headerStyle: {
        minWidth: "130px",
      },
      style: {
        fontWeight: "bold"
      },
    },
    {
      dataField: "foodTasting",
      text: "Food Tasting",
      headerStyle: {
        minWidth: "130px",
      },
      style: {
        fontWeight: "bold"
      },
    },
    {
      dataField: "designSelection",
      text: "Design Selection",
      headerStyle: {
        minWidth: "170px",
      },
      style: {
        fontWeight: "bold"
      },
    },
    {
      dataField: "sendingQuote",
      text: "Sending Quote",
      headerStyle: {
        minWidth: "130px",
      },
      style: {
        fontWeight: "bold"
      },
    },
    {
      dataField: "callOpening",
      text: "Call Opening",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "callClosing",
      text: "Call Closing",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "probing",
      text: "Client Profile Probing",
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "crossPitch",
      text: "Range Probing",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "urgencyToSell",
      text: "Closure Pitch",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "rapport",
      text: "Rapport",
      sort: true,
      headerStyle: {
        minWidth: "135px",
      },
    },
    {
      dataField: "clientVisit",
      text: "Client Visit",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "clientDetails",
      text: "Client Details",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "eventDetails",
      text: "Event Details",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "budgetDetails",
      text: "Budget Details",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "clientProfile",
      text: "Client Profile",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "futureFollowupDate",
      text: "Future Followup Date",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "195px",
      },
    },
    {
      dataField: "venueDetails",
      text: "Venue Details",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "salesPyramid",
      text: "Sale Pyramid",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "auditOn",
      text: "Audit Date",
      sort: true,
      headerStyle: {
        minWidth: "185px",
      },
    },
    {
      dataField: "auditName",
      text: "Audit Name",
      sort: true,
      headerStyle: {
        minWidth: "185px",
      },
    },
    {
      dataField: "remarks",
      text: "Audit Remarks",
      sort: true,
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "greenFlag",
      text: "Green Flag Remarks",
      sort: true,
      headerStyle: {
        minWidth: "195px",
      },
    },
  ]

  // pagination options
  const options = {
    sizePerPage: 50,
    totalSize: followup_feedback_report.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Reports"} breadcrumbItem={title} />

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="companies"
                          isMulti
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            followupFeedbackData
                              ? followupFeedbackData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                          zIndex="2"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branches"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Lead No"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          placeholder="Enter Lead No"
                          name="leadNo"
                          value={followupData.leadNo}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Followup From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={followupData.fromDate}
                          max={followupData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Followup To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={followupData.toDate}
                          min={followupData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Audit From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="auditFromDate"
                          value={followupData.auditFromDate}
                          max={followupData.auditToDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Audit To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="auditToDate"
                          value={followupData.auditToDate}
                          min={followupData.auditFromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Sales Agent"}
                          </Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="salesAgent"
                          items={salesAgentOptions}
                          key={agentKey}
                          value={salesAgent}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setSalesAgent(e)}
                          onChange={(e) => setSalesAgent(e.target.value)}
                          placeholder="Enter Sales Agent"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="button"
                            onClick={() => applyFilter()}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(options)}
                    keyField="_id"
                    columns={columns}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="_id"
                        data={followupReportTable}
                        columns={columns}
                        search
                        exportCSV
                      >
                        {(props) => (
                          <div>
                            <Col md="12" xl="12" lg="12" sm="12" xs="12">
                              <Row className="d-flex flex-row  ">
                                <Col className="mb-3" md="4">
                                  <div className="d-flex flex-row ">
                                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                      <div
                                        className="position-relative mt-7"
                                        style={searchBarStyle || null}
                                      >
                                        <SearchBar {...props.searchProps} />
                                        <i className="bx bx-search-alt search-icon" />
                                      </div>
                                    </div>
                                  </div>{" "}
                                </Col>

                                <Col>
                                  <ExportCSVButton
                                    className="border float-right mx-10"
                                    style={{
                                      float: "right",
                                      backgroundColor: "#e40d8c",
                                      color: "#ffffff",
                                    }}
                                    {...props.csvProps}
                                  >
                                    Download{" "}
                                  </ExportCSVButton>{" "}
                                  {/* <Col className="bootstrap-table-filter">
                                    <div style={{ marginRight: "20px" }}>
                                      <Multiselect
                                        options={columns
                                          .filter((_) => _.hidden)
                                          .map((el) =>
                                            Object.assign(
                                              {},
                                              {
                                                label: el.text,
                                                value: el.dataField,
                                              }
                                            )
                                          )}
                                        selectedValues={tableFilterOpt}
                                        onSelect={(selVal) => {
                                          // columns
                                          //   .filter((_) => _.hidden)
                                          //   .map((el) => {

                                          setTableFilterOpt(selVal)
                                          // if (
                                          //   selVal &&
                                          //   selVal.map(
                                          //     (val) => val.value
                                          //   ) === el.dataField
                                          // ) {
                                          setDropdownSelect(true)
                                          // }
                                        }}
                                        onRemove={(remVal) => {
                                          setTableFilterOpt(remVal)
                                        }}
                                        displayValue="label"
                                        showCheckbox
                                        placeholder={
                                          tableFilterOpt &&
                                          tableFilterOpt.length > 0
                                            ? `${tableFilterOpt.length} Item${
                                                tableFilterOpt.length > 1
                                                  ? "s"
                                                  : ""
                                              } Selected`
                                            : "Select Column"
                                        }
                                      />
                                    </div>
                                  </Col> */}
                                </Col>
                                <Col>
                                  <BootstrapTable
                                    {...props.baseProps}
                                    responsive
                                    striped={true}
                                    bordered={true}
                                    keyField="events"
                                    columns={columns}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                              <Row
                                style={{ marginTop: "5px" }}
                                className="align-items-md-center mt-30"
                              >
                                <Col className="inner-custom-pagination d-flex">
                                  <div className="d-inline d-flex flex-row">
                                    <SizePerPageDropdownStandalone
                                      {...paginationProps}
                                    />
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        marginTop: "8px",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      <PaginationTotalStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className="text-md-right ms-auto"
                                    style={{ zIndex: 0 }}
                                  >
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

FollowupFeedback.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FollowupFeedback)
)
